{
  "version": 1,
  "asset_id": "2dfb5447-b0eb-469a-8ec0-d786667a0cce",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2dfb5447-b0eb-469a-8ec0-d786667a0cce/hero-new-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2dfb5447-b0eb-469a-8ec0-d786667a0cce/hero-new-1280.webp",
  "original_filename": "hero-new-1280.webp",
  "size": 69016,
  "content_type": "image/webp",
  "created_at": "2026-07-25T03:21:15Z"
}
